import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResponseServiceModel } from 'src/app/shared/models/response-service.model';
import { Observable } from 'rxjs';
import { retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnviromentGlobalService } from 'src/app/shared/services/enviroment-global.service';



@Injectable()
export class VizualizacionNoSuperadaComponentService {

	private API_URL;
  constructor(private http: HttpClient, private enviromentGlobalService: EnviromentGlobalService) {
		this.API_URL = enviromentGlobalService.apiUrl;
  }

	getDataTable(numeroPagina: number,entry: any): Observable<ResponseServiceModel> {
		// tslint:disable-next-line:max-line-length
		return this.http.post<ResponseServiceModel>(`${this.API_URL}/RntsNoSuperada/Obtener/0?PageNumber=${numeroPagina}&PageSize=12&QueryType=A`, entry).pipe(
			retry(2)
		);
	}



	getTipoSolicitud(): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/Solicitud/GetTipoSolicitudesReportes`).pipe(
			retry(2)
		);
	}


  	generarExportarTramites(entry: any) {
      return this.http.post(`${this.API_URL}/RntsNoSuperada/ExportarRegistros`, entry, {
        responseType: 'blob',
        observe: 'response'
      }).pipe(
        retry(2)
      );
	}
}
